<template>
    <v-container>
        <v-card flat class="text-xs-center">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Datos Contacto </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">mdi-card-account-phone</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <vs-list-item title="Telefonos"></vs-list-item>
                <v-list v-for="item in telefonos" :key="item.stid">
                    <v-list-item>
                        <v-list-item-icon>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" v-text="item.icon"></v-icon>
                                </template>
                                <span v-text="item.sttdescripcion"></span>
                            </v-tooltip>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <span id="actor">{{ item.stadescripcion }}</span>
                            <!-- <v-list-item-title id="actor"></v-list-item-title> -->
                            <v-list-item-subtitle id="telefono">{{ item.Column1 + ' ' + item.stnumero
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                </v-list>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import telefonos from '@/services/Telefonos/Telefonos.service.js';

export default {
    data: function () {
        return {
            telefonos: [],
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    async mounted() {
        this.ObtenerTelefonos()
    },
    methods: {
        ObtenerTelefonos() {
            telefonos.Telefonos(this).then(datostel => {
                this.telefonos = []
                this.telefonos = datostel;
            });
        }
    }
}
</script>

<style scoped>
.mdi-home,
.mdi-cellphone,
.mdi-briefcase,
.mdi-cellphone-off {
    color: #3CD4A0 !important;
}

#actor {
    font-size: 12px !important;
    font-weight: 0 !important;
}

#telefono {
    font-size: 20px;
    font-weight: 700;
}
</style>
